import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const AGBPage = () => {
  return (
    <div className="min-h-screen bg-[#0a0a0a] text-gray-300">
      <div className="max-w-3xl mx-auto px-4 lg:px-8 py-20">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-gray-500 hover:text-white transition-colors mb-10">
          <ArrowLeft size={16} /> Zurück zur Startseite
        </Link>

        <h1 className="text-3xl font-bold text-white mb-8">Allgemeine Geschäftsbedingungen (AGB)</h1>

        <div className="space-y-6 text-sm leading-relaxed">

          <div>
            <h2 className="text-lg font-semibold text-white mb-2">§ 1 Geltungsbereich</h2>
            <p>
              (1) Diese Allgemeinen Geschäftsbedingungen (nachfolgend „AGB") gelten für alle
              Geschäftsbeziehungen zwischen Northlight Visuals, Michelle Inci, Stadtwiesen 17, 90522
              Oberasbach (nachfolgend „Auftragnehmer") und dem jeweiligen Auftraggeber (nachfolgend
              „Kunde"), soweit nicht etwas anderes ausdrücklich schriftlich vereinbart wurde.
            </p>
            <p className="mt-2">
              (2) Abweichende, entgegenstehende oder ergänzende AGB des Kunden werden nur dann
              Vertragsbestandteil, wenn und soweit der Auftragnehmer ihrer Geltung ausdrücklich schriftlich
              zugestimmt hat.
            </p>
            <p className="mt-2">
              (3) Diese AGB gelten auch für alle zukünftigen Geschäfte mit dem Kunden, soweit es sich um
              Rechtsgeschäfte verwandter Art handelt.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-semibold text-white mb-2">§ 2 Leistungsgegenstand</h2>
            <p>
              (1) Der Auftragnehmer erbringt Dienstleistungen im Bereich der digitalen Bildproduktion,
              insbesondere die Erstellung von Fashion-, Produkt- und Kampagnenvisuals, inklusive
              professioneller Nachbearbeitung (High-End Retouching).
            </p>
            <p className="mt-2">
              (2) Der konkrete Leistungsumfang ergibt sich aus der individuellen Projektvereinbarung
              (Angebot, Auftragsbestätigung oder schriftliche Absprache).
            </p>
            <p className="mt-2">
              (3) Änderungen oder Erweiterungen des Leistungsumfangs bedürfen der schriftlichen
              Vereinbarung und können zu einer Anpassung der Vergütung und Lieferzeiten führen.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-semibold text-white mb-2">§ 3 Vertragsschluss</h2>
            <p>
              (1) Angebote des Auftragnehmers sind freibleibend und unverbindlich, sofern sie nicht
              ausdrücklich als verbindlich gekennzeichnet sind.
            </p>
            <p className="mt-2">
              (2) Ein Vertrag kommt zustande durch die schriftliche Auftragsbestätigung des Auftragnehmers
              oder durch tatsächliche Leistungserbringung.
            </p>
            <p className="mt-2">
              (3) Terminbuchungen über die Website stellen eine unverbindliche Anfrage für ein Erstgespräch
              dar und begründen noch kein Vertragsverhältnis über die Erbringung von Produktionsleistungen.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-semibold text-white mb-2">§ 4 Mitwirkungspflichten des Kunden</h2>
            <p>
              (1) Der Kunde stellt dem Auftragnehmer alle für die Durchführung des Auftrags erforderlichen
              Unterlagen, Materialien und Informationen rechtzeitig und unentgeltlich zur Verfügung.
              Hierzu gehören insbesondere Produktfotos, Produktmuster, Markenrichtlinien und Stilwünsche.
            </p>
            <p className="mt-2">
              (2) Sofern der Kunde physische Produkte für Studioaufnahmen zur Verfügung stellt, trägt der
              Kunde die Versandkosten für den Hin- und Rückversand. Der Auftragnehmer behandelt
              zugesandte Produkte sorgfältig und sendet diese nach Abschluss der Produktion an den Kunden
              zurück.
            </p>
            <p className="mt-2">
              (3) Verzögerungen aufgrund fehlender Mitwirkung des Kunden gehen nicht zulasten des
              Auftragnehmers und können zu einer Anpassung vereinbarter Liefertermine führen.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-semibold text-white mb-2">§ 5 Vergütung und Zahlungsbedingungen</h2>
            <p>
              (1) Die Vergütung richtet sich nach der individuellen Projektvereinbarung. Alle Preise
              verstehen sich in Euro.
            </p>
            <p className="mt-2">
              (2) Rechnungen sind innerhalb von 14 Tagen nach Rechnungsstellung ohne Abzug zu begleichen,
              sofern nicht anders vereinbart.
            </p>
            <p className="mt-2">
              (3) Der Auftragnehmer ist berechtigt, bei umfangreicheren Projekten eine Anzahlung in Höhe
              von bis zu 50 % der vereinbarten Vergütung vor Beginn der Leistungserbringung zu verlangen.
            </p>
            <p className="mt-2">
              (4) Bei Zahlungsverzug ist der Auftragnehmer berechtigt, Verzugszinsen in gesetzlicher Höhe
              zu berechnen.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-semibold text-white mb-2">§ 6 Lieferung und Abnahme</h2>
            <p>
              (1) Liefertermine sind, sofern nicht ausdrücklich als verbindlich vereinbart, unverbindlich
              und stellen lediglich eine voraussichtliche Zeitangabe dar.
            </p>
            <p className="mt-2">
              (2) Die Lieferung der erstellten Visuals erfolgt in der Regel digital in den vereinbarten
              Dateiformaten und Auflösungen.
            </p>
            <p className="mt-2">
              (3) Der Kunde hat die gelieferten Visuals innerhalb von 7 Werktagen nach Lieferung zu prüfen
              und etwaige Mängel schriftlich zu rügen. Nach Ablauf dieser Frist gelten die Visuals als
              abgenommen.
            </p>
            <p className="mt-2">
              (4) Im vereinbarten Leistungsumfang enthaltene Korrekturschleifen werden vom Auftragnehmer
              durchgeführt. Darüber hinausgehende Änderungswünsche können zusätzlich vergütet werden.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-semibold text-white mb-2">§ 7 Nutzungsrechte</h2>
            <p>
              (1) Mit vollständiger Bezahlung der vereinbarten Vergütung räumt der Auftragnehmer dem Kunden
              das einfache, zeitlich und räumlich unbeschränkte Nutzungsrecht an den erstellten Visuals
              für die vereinbarten Verwendungszwecke ein, sofern nicht anders vereinbart.
            </p>
            <p className="mt-2">
              (2) Eine Weitergabe der Nutzungsrechte an Dritte bedarf der vorherigen schriftlichen
              Zustimmung des Auftragnehmers, es sei denn, die Weitergabe erfolgt im Rahmen der
              vertragsgemäßen Nutzung (z. B. an Agenturen, Plattformen oder Druckdienstleister).
            </p>
            <p className="mt-2">
              (3) Der Auftragnehmer ist berechtigt, die erstellten Visuals zu Referenzzwecken in seinem
              eigenen Portfolio zu verwenden, sofern der Kunde dem nicht ausdrücklich schriftlich
              widerspricht (Diskretion auf Wunsch).
            </p>
          </div>

          <div>
            <h2 className="text-lg font-semibold text-white mb-2">§ 8 Vertraulichkeit und Diskretion</h2>
            <p>
              (1) Der Auftragnehmer verpflichtet sich, alle im Rahmen der Zusammenarbeit erhaltenen
              Informationen und Materialien des Kunden vertraulich zu behandeln.
            </p>
            <p className="mt-2">
              (2) Auf ausdrücklichen Wunsch des Kunden werden weder Markenname, Produkte noch erstellte
              Visuals vom Auftragnehmer veröffentlicht oder zu Referenzzwecken verwendet.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-semibold text-white mb-2">§ 9 Haftung</h2>
            <p>
              (1) Der Auftragnehmer haftet unbeschränkt für Vorsatz und grobe Fahrlässigkeit.
            </p>
            <p className="mt-2">
              (2) Für leichte Fahrlässigkeit haftet der Auftragnehmer nur bei Verletzung wesentlicher
              Vertragspflichten (Kardinalpflichten). In diesem Fall ist die Haftung auf den
              vorhersehbaren, vertragstypischen Schaden begrenzt.
            </p>
            <p className="mt-2">
              (3) Die Haftung für Schäden aus der Verletzung des Lebens, des Körpers oder der Gesundheit
              bleibt unberührt.
            </p>
            <p className="mt-2">
              (4) Der Auftragnehmer haftet nicht für Schäden, die durch fehlerhafte oder unvollständige
              Angaben und Materialien des Kunden entstehen.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-semibold text-white mb-2">§ 10 Stornierung und Kündigung</h2>
            <p>
              (1) Der Kunde kann den Auftrag vor Beginn der Leistungserbringung kostenfrei stornieren.
            </p>
            <p className="mt-2">
              (2) Bei Stornierung nach Beginn der Leistungserbringung ist der Auftragnehmer berechtigt,
              die bis dahin erbrachten Leistungen in Rechnung zu stellen.
            </p>
            <p className="mt-2">
              (3) Das Recht zur Kündigung aus wichtigem Grund bleibt für beide Parteien unberührt.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-semibold text-white mb-2">§ 11 Schlussbestimmungen</h2>
            <p>
              (1) Es gilt das Recht der Bundesrepublik Deutschland.
            </p>
            <p className="mt-2">
              (2) Sollten einzelne Bestimmungen dieser AGB unwirksam sein oder werden, so bleibt die
              Wirksamkeit der übrigen Bestimmungen davon unberührt.
            </p>
            <p className="mt-2">
              (3) Änderungen und Ergänzungen dieser AGB bedürfen der Schriftform. Dies gilt auch für die
              Aufhebung dieses Schriftformerfordernisses.
            </p>
          </div>

          <p className="text-gray-600 text-xs mt-8">Stand: Juni 2026</p>
        </div>
      </div>
    </div>
  );
};

export default AGBPage;
